import pfmClientAxiosInstance from './interceptor';

export const getDetails = (data: any) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/get-details/${data.type}`
  );
};

export const getAnalyticsStatus = () => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/analytics-status`
  );
};

export const getStockInshights = (rangeFilter: string) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/insights?rangeFilter=${rangeFilter}`
  );
};

export const getOverallFields = () => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/overallFields`
  );
};

export const getStocksHoldings = (data: any) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/holdings`
  );
};

export const fetchRawData = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/raw-data`,
    data
  );
};

export const getTransactions = (data: any, config?: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/transactions?${
      config?.page !== undefined ? `page=${config?.page}` : ''
    }${config?.page !== undefined ? `&size=${config?.pageSize}` : ''}`,
    data
  );
};

export const getCashFlow = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/get-cash-flow`,
    data
  );
};

export const sendSessionId = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/sessionId`,
    data
  );
};

export const getMonthFilterTransactions = (data: string) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/transaction-months/${data}`
  );
};

export const refreshApi = (trackingId? : string, fiTypeList?: string[], fiIntegrationTypeList?: string[]) => {
  const body: Record<string, string[] | string> = {};
  if (fiTypeList) body.fiTypeList = fiTypeList;
  if (fiIntegrationTypeList) body.fiIntegrationTypeList = fiIntegrationTypeList;
  if (trackingId) body.trackingId = trackingId;
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/data/refresh`,
    body
  );
};

export const revokeConsentAPI = (data: { referenceId: string }) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/consent/revoke`,
    data
  );
};

export const getTrends = (data: any, config?: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/trends`,
    data
  );
};

export const getListOfCategories = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/account/categoryCode`,
    data
  );
};

export const getListOfFips = () => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/get-fip`
  );
};

export const createManualFD = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/create/manual-fd`,
    data
  );
};